import { FC, SyntheticEvent, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Tab, Tabs, Typography } from '@mui/material';

import { TAdminInquiriesPageTab } from '@interfaces/adminInquiries';

import AdminInquiryList from './AdminInquiryList/AdminInquiryList';

import './style.scss';

const AdminInquiriesPage: FC = () => {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState(TAdminInquiriesPageTab.Pending);
  const isPending = activeTab === TAdminInquiriesPageTab.Pending;

  const handleTabChange = useCallback((event: SyntheticEvent, value: TAdminInquiriesPageTab) => {
    setActiveTab(value);
  }, []);

  return (
    <Container maxWidth="lg" className="page admin-inquiries-page">
      <Typography variant="h1" className="admin-inquiries-page__title">
        {t('adminInquiries.title')}
      </Typography>

      <div className="admin-inquiries-page__content">
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="Tabs"
          className="admin-inquiries-page__tabs"
        >
          <Tab
            value={TAdminInquiriesPageTab.Pending}
            label={`${t('adminInquiries.pendingInquiries')}`}
          />

          <Tab value={TAdminInquiriesPageTab.Sent} label={`${t('adminInquiries.sentInquiries')}`} />
        </Tabs>

        <AdminInquiryList isPending={isPending} />
      </div>
    </Container>
  );
};

export default AdminInquiriesPage;
